import {indexOf} from 'lodash';
import {IDiplomatAdminUser} from 'types/DiplomatAdminUser';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType, DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';
import {TransportType, TransportTypeUnion} from 'types/TransportType';

export const isKey = (data: IDiplomatObject) =>
   indexOf(
      [
         DiplomatObjectType.enum.KEY_PAIR,
         DiplomatObjectType.enum.PUBLIC_KEY,
         DiplomatObjectType.enum.SSH_KEY,
         DiplomatObjectType.enum.SSH_HOST_KEY,
         DiplomatObjectType.enum.SSL_CERTIFICATE,
         DiplomatObjectType.enum.SSL_CLIENT_CERTIFICATE,
      ],
      data.objectType
   ) >= 0;

export const isParnter = (data: IDiplomatObject) =>
   indexOf(
      [DiplomatObjectType.enum.INTERNAL_PARTNER, DiplomatObjectType.enum.EXTERNAL_PARTNER],
      data.objectType
   ) >= 0;
export const isTransaction = (data: IDiplomatObject) =>
   indexOf(
      [DiplomatObjectType.enum.INBOUND_TRANSACTION, DiplomatObjectType.enum.OUTBOUND_TRANSACTION],
      data.objectType
   ) >= 0;
export const isSynchronization = (data: IDiplomatObject) =>
   data.objectType === DiplomatObjectType.enum.SYNCHRONIZATION;

export const isTransactionOrSyncByType = (objectType: DiplomatObjectTypeUnion) =>
   indexOf(
      [
         DiplomatObjectType.enum.INBOUND_TRANSACTION,
         DiplomatObjectType.enum.OUTBOUND_TRANSACTION,
         DiplomatObjectType.enum.SYNCHRONIZATION,
      ],
      objectType
   ) >= 0;

export const isFileLockingAvailableForTransport = (transportType: Partial<TransportTypeUnion>) =>
   indexOf([TransportType.enum.FILE_SYSTEM, TransportType.enum.SMB], transportType) >= 0;

export const isIdleAvailableForTransport = (transportType: Partial<TransportTypeUnion>) =>
   indexOf(
      [
         TransportType.enum.FILE_SYSTEM,
         TransportType.enum.FTP,
         TransportType.enum.FTPS,
         TransportType.enum.SFTP,
         TransportType.enum.SMB,
         TransportType.enum.AMAZONS3,
         TransportType.enum.AZURE_STORAGE,
         TransportType.enum.CLOUD,
         TransportType.enum.SHAREPOINT,
      ],
      transportType
   ) >= 0;
export const isLocalNetwork = (type: TransportTypeUnion) => type === TransportType.enum.FILE_SYSTEM;

export const isSFTP = (objectType: DiplomatObjectTypeUnion) =>
   indexOf(
      [
         DiplomatObjectType.enum.VFS,
         DiplomatObjectType.enum.VFS_GROUP,
         DiplomatObjectType.enum.SFTP_USER,
         DiplomatObjectType.enum.SFTP_SERVER,
      ],
      objectType
   ) >= 0;

export const transformAdminUsers = (users: IDiplomatAdminUser[]) =>
   users.map((u) => ({...u, name: u.name || u.userName}));
